import styled from 'styled-components';

export const StyledSlider = styled.div`
  width: 100%;

  & > div {
    height: var(--main-height);
    min-height: 100%;
  }
`;

export const StyledSlide = styled.span`
  display: flex;
  padding: 40px var(--side-padding) 48px;
  height: var(--main-height);
`;

export const StyledButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
  background-color: var(--fill-color-body);
  border: none;
  outline: none;
  border-radius: 100%;
  cursor: pointer;
  padding: 0;

  svg {
    width: 48px;
    height: 48px;
    color: var(--border-color-active-invert);
  }
`;

export const StyledButtonNext = styled(StyledButton)`
  position: absolute;
  right: var(--side-padding);
`;

export const StyledButtonPrev = styled(StyledButton)`
  position: absolute;
  left: var(--side-padding);
`;
